import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FILES } from "../domain";

import { filesApi } from "@api/services";
import { ACTION_GET_FOLDER, DOMAIN_FOLDERS, roleGuard } from "@api";

export const ACTION_DELETE_FILE_FROM_FOLDER = "DELETE_FILE_FROM_FOLDER";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const deleteFileFromFolder = async (fileId: string): Promise<void> => {
  await filesApi.filesControllerDeleteFile(fileId);
};

export const useDeleteFileFromFolder = (
  user: UserProfileDto | null,
): {
  deleteFileFromFolderAsync: UseMutateFunction<void, Error, string, unknown>;
  deleteFileFromFolderEnabled: boolean;
  isSuccessFileFromFolder: boolean;
  isPendingFileFromFolder: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FILES, ACTION_DELETE_FILE_FROM_FOLDER],
    mutationFn: enabled ? deleteFileFromFolder : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_FOLDERS, ACTION_GET_FOLDER],
      });
    },
  });

  return {
    deleteFileFromFolderAsync: mutateAsync,
    deleteFileFromFolderEnabled: enabled,
    isSuccessFileFromFolder: isSuccess,
    isPendingFileFromFolder: isPending,
  };
};
